import da from './da-DK.json';
import en from './en-US.json';
import de from './de-DE.json';
import fi from './fi-FI.json';
import no from './nb-NO.json';
import pl from './pl-PL.json';
import se from './sv-SE.json';

export default {
  'da-DK': da,
  'en-US': en,
  'de-DE': de,
  'fi-FI': fi,
  'nb-NO': no,
  'pl-PL': pl,
  'sv-SE': se,
};
